import { useMemo } from 'react'

import { Dropdown } from 'core-components/library/dropdown'
import { Tooltip } from 'core-components/library/tooltip'
import { BaseCrud, Static } from 'core-components/types'

import { IRowsPerPageOption, TTitleRenderFunction } from '../types'

import styles from './SelectRowsCount.module.scss'

interface IProps<T, R> {
  className?: string
  pageSize: number
  source: BaseCrud<T, R>
  rowsPerPageOptions?: IRowsPerPageOption[]
  titleRender?: TTitleRenderFunction
}

export const SelectRowsCount = <T, R>({
  className,
  pageSize,
  source,
  rowsPerPageOptions,
  titleRender,
}: IProps<T, R>) => {
  const defaultRowsPerPageOptions = [
    { key: 5, value: '5' },
    { key: 10, value: '10' },
    { key: 25, value: '25' },
    { key: 50, value: '50' },
    { key: 100, value: '100' },
    { key: 3000, value: 'All' },
  ]
  const selectSource = useMemo(() => {
    const rawData = rowsPerPageOptions ? [...rowsPerPageOptions] : [...defaultRowsPerPageOptions]
    const hasCurrentPageSize = rawData.find((element) => element.key === pageSize)
    if (!hasCurrentPageSize) {
      rawData.push({ key: pageSize, value: pageSize + '' })
      rawData.sort((f, s) => f.key - s.key)
    }
    return new BaseCrud({
      fetcher: new Static(rawData),
      keyField: 'key',
    })
  }, [])

  return (
    <div className={className || ''} data-testid={'table-paging'}>
      <Tooltip
        tipContent={() => (
          <>{(titleRender && titleRender('rowsCount', 'items on page')) || 'items on page'}</>
        )}
      >
        <Dropdown
          classes={{ controlClasses: { root: styles.dropdown } }}
          source={selectSource}
          caption={'value'}
          value={pageSize}
          onChange={(key: string) => {
            source.setPaging({
              page: source.getPaging().startPage ?? 0,
              pageSize: +key,
              startPage: source.getPaging().startPage,
            })
          }}
        />
      </Tooltip>
    </div>
  )
}
